import { render, staticRenderFns } from "./DecoVote.vue?vue&type=template&id=0d0715a6&"
import script from "./DecoVote.vue?vue&type=script&lang=ts&"
export * from "./DecoVote.vue?vue&type=script&lang=ts&"
import style0 from "./DecoVote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports